import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { SessionService } from '../../../services/session.service';
import { Cliente } from '../../../models/cliente';
import { ClienteService } from '../../../services/cliente.service';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { ValidarCorreoService } from '../../../services/validar-correo.service';

@Component({
	selector: 'app-cliente-edit',
	templateUrl: './cliente-edit.component.html',
	styleUrls: ['./cliente-edit.component.css'],
	providers: [
		ClienteService,
		SessionService,
		ValidarCorreoService
	]
})
export class ClienteEditComponent implements OnInit {
	@ViewChild('identificacionFocus') identificacionElement: ElementRef;
	public title: String;
	public cliente: Cliente;
	public msg: SweetMessage;
	public vl: Validation;
	public loading = false;
	public correos: Array<any>;
	public correo_invalid: Boolean;

	constructor(
		private clienteService: ClienteService,
		private storage: AsyncLocalStorage,
		private ss: SessionService,
		public fb: FormBuilder,
		public correoService: ValidarCorreoService,
	) {
		this.title = "Editar cliente";
		this.msg = new SweetMessage();
		this.vl = new Validation();
		this.cliente = new Cliente();
		this.cliente.tipo_identificacion_id = 1;
		this.correos = [];
		this.correo_invalid = false;
	}

	ngOnInit() {
		this.storage.getItem("cliente").subscribe(data => {
			this.cliente = data;
			
			if( this.cliente.correo.trim().length ){
				this.correos = this.cliente.correo.split(',');
			}
		});
	}

	onSubmit() {
		//setea valores del formulario a la entidad
		this.setValueEntity();
		this.loading = true;
		this.clienteService.update(this.cliente).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message',err)
			}
		);
	}

	setValueEntity() {
		this.cliente.empresa_id = this.ss.getData("empresa_id");
		this.cliente.usuario_id = this.ss.getData("usuario_id");
		this.cliente.correo = this.correos.toString();
		this.cliente.razon_social = this.cliente.razon_social.trim();
		this.cliente.nombre_comercial = this.cliente.nombre_comercial.trim();
		switch (this.cliente.tipo_identificacion_id){
			case 1: 
				this.cliente.tipo_dni = "RUC";
				break;
			case 2: 
				this.cliente.tipo_dni = "CED";
				break;
			case 3:
				this.cliente.tipo_dni = "PAS";
				break;
			case 4:
				this.cliente.tipo_dni = "CFINAL";
				break;
		}
	}

	isValidForm(){
		if(!this.cliente.razon_social){
			return false;
		}

		if(this.cliente.nombre_comercial =='' && this.cliente.tipo_persona!='N'){
			return false
		}

		if(!this.cliente.dni){
			return false;
		}

		if(!this.cliente.tipo_identificacion_id){
			return false;
		}

		if(!this.cliente.tipo_persona){
			return false;
		}

		if(!this.cliente.direccion){
			return false;
		}

		if(!this.cliente.telefono){
			return false;
		}

		/*if(this.cliente.es_contribuyente){
			if(!this.cliente.num_contribuyente){
				return false;
			}
		}*/
		if(this.cliente.dni){
			if(this.cliente.tipo_identificacion_id == 1 || this.cliente.tipo_identificacion_id == 4){
				if( this.cliente.dni.length < 13 ){
					return false;
				}else if( isNaN(this.cliente.dni.toString() as any) ){
					return false;
				}
			}
			if(this.cliente.tipo_identificacion_id == 2){
				if( this.cliente.dni.length < 10 ){
					return false;
				}else if( isNaN(this.cliente.dni.toString() as any) ){
					return false;
				}
			}
			if(this.cliente.tipo_identificacion_id == 3 && this.cliente.dni.length < 4){
				return false;
			}
		}

		if(this.cliente.telefono && this.cliente.telefono.length < 4){
			return false;
		}

		if(this.cliente.celular && this.cliente.celular.length < 4){
			return false;
		}
		/*if( !this.correos.length ){
			return false;
		}*/
		if (this.correo_invalid) {
			return false;
		}

		return true;
	}

	onChangeIdentificacion(id){
		this.cliente.tipo_identificacion_id = id;
		if( this.cliente.tipo_identificacion_id == 4 ){
			this.cliente.dni = "9999999999999"
		}else{
			this.msg.showMessage('error-message',"Ingrese número de identificación")
			this.cliente.dni = "";
		}
		setTimeout(()=>{ 
			this.identificacionElement.nativeElement.focus();
		},0);

	}
	onChangeTipoPersona(){
		if(this.cliente.tipo_persona == 'N'){
			this.cliente.nombre_comercial = '';
		}

		setTimeout(()=>{ 
			this.identificacionElement.nativeElement.focus();
		},0);
	}

	validarCorreo() {
		if (this.correos.length > 0) {
			let count_true = 0;
			let count_false = 0;
			for (let index = 0; index < this.correos.length; index++) {
				let res = this.correoService.isEmailValido(this.correos[index]);
				if (res) {
					count_true++;

				} else {
					count_false++;
				}

			}
			if (count_false > 0) {
				this.correo_invalid = true;
			} else {
				this.correo_invalid = false;
			}


		} else {
			this.correo_invalid = false;
		}
	}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/cliente-edit/cliente-edit.component.ts